<div
  class="border border-gray-100 dark:border-coal-600 rounded-xl relative bg-white dark:bg-coal-700 overflow-hidden"
>
  <div
    class="chart-card-header flex items-center justify-between px-5 py-4"
  >
    <span class="chart-card-title text-gray-900 dark:text-white">
      Standards and Framework Readiness
    </span>

    <button routerLink="/eciso/framework-library" class="btn btn-link btn-sm shrink-0">
      View More
    </button>
  </div>
  <div class="separator opacity-60"></div>

  <!-- SKELETON LOADER -->
  <div class="relative" *ngIf="isLoading">
    <!-- Scrollable Skeleton Cards -->
    <div class="flex flex-nowrap overflow-x-auto no-scrollbar gap-4 px-6 py-5">
      <div
        *ngFor="let sk of skeletonItems; let i = index"
        class="scroll-card flex-shrink-0 bg-slate-50/50 dark:bg-coal-800/20 border border-gray-100/80 dark:border-coal-600/30 rounded-xl p-3.5 flex items-center gap-3.5"
      >
        <!-- Icon circle skeleton -->
        <div class="w-12 h-12 rounded-full shimmer-item flex-shrink-0"></div>

        <!-- Text skeleton -->
        <div class="flex flex-col gap-2 w-full">
          <div class="h-4 w-12 shimmer-item rounded"></div>
          <div class="h-3 w-24 shimmer-item rounded"></div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="relative mx-auto max-w-full"
    [style.width]="containerWidth"
    *ngIf="!isLoading"
  >
    <!-- Left Arrow Button -->
    <img
      *ngIf="showLeftArrow"
      src="assets/media/icons/left-arrow.png"
      class="absolute top-1/2 left-2 -translate-y-1/2 cursor-pointer h-8 w-8 bg-white dark:bg-coal-700 rounded-full z-10 ms-2"
      (click)="scrollLeft(scrollContainer)"
    />

    <!-- Scrollable Content -->
    <div
      #scrollContainer
      class="flex flex-nowrap overflow-x-auto no-scrollbar scroll-smooth gap-4 px-6 py-5 w-full"
      (scroll)="onScroll(scrollContainer)"
    >
      <div
        *ngFor="let item of fieldsData; let i = index"
        class="scroll-card relative flex-shrink-0 bg-gray dark:bg-coal-500 border border-gray-100 dark:border-coal-600/60 rounded-xl p-3.5 flex items-center gap-3.5 transition-all duration-300 dark:hover:border-coal-500 hover:scale-[1.02]"
        [class.cursor-pointer]="canNavigate()"
        [class.selected]="item.mySelected"
        (click)="navigateToTasks(item)"
      >
        <!-- Selected Checkmark Icon -->
        <i
          *ngIf="item.mySelected"
          class="absolute top-2 right-2 ki-solid ki-check-circle text-xl text-success"
          style="z-index: 5"
        ></i>
        <!-- Dynamic Progress Circle Ring -->
        <div
          class="relative flex items-center justify-center flex-shrink-0 w-14 h-14"
        >
          <svg class="w-full h-full transform -rotate-90" viewBox="0 0 36 36">
            <!-- Background track -->
            <path
              class="progress-ring-track"
              stroke-width="3"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <!-- Progress value path -->
            <path
              class="progress-ring-value progress-ring-emerald"
              stroke-width="3"
              [attr.stroke-dasharray]="(item.completedPercent || 0) + ', 100'"
              stroke-linecap="round"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <!-- Logo container in the center -->
          <div
            class="absolute w-9 h-9 rounded-full flex items-center justify-center overflow-hidden"
          >
            <img
              *ngIf="!item.logo"
              src="assets/media/icons/security.png"
              class="w-full h-full object-contain rounded-full"
            />
            <img
              *ngIf="item.logo"
              [src]="item.logo"
              (error)="item.logo = ''"
              class="w-full h-full object-contain rounded-full"
            />
          </div>
        </div>

        <!-- Text Description -->
        <div class="flex flex-col items-start gap-0.5 overflow-hidden min-w-0">
          <span
            class="text-lg font-bold text-gray-900 dark:text-gray-100 tracking-tight leading-none"
            [class.text-success]="(+item.completedPercent || 0) === 100"
          >
            {{ item.completedPercent ?? 0 | number: "1.2-2" }}%
          </span>
          <span
            class="text-xs text-gray-500 dark:text-gray-400 font-semibold truncate w-full"
            [title]="item.key.framework"
          >
            {{ item.key.framework }}
          </span>
        </div>
      </div>
    </div>

    <!-- Right Arrow Button -->
    <img
      *ngIf="showRightArrow"
      src="assets/media/icons/arrow.png"
      class="absolute top-1/2 right-2 -translate-y-1/2 cursor-pointer h-8 w-8 bg-white dark:bg-coal-700 rounded-full shadow-md"
      (click)="scrollRight(scrollContainer)"
    />
  </div>
</div>
